module.exports = __webpack_public_path__ + "static/legal-fdf3e142578eefe23c02e2155e3cfd4c.png";